import { AppFrame } from '@/design-system/chrome/AppFrame';
import { SectionHeader } from '@/design-system/primitives/SectionHeader/SectionHeader';

interface ScreenStubProps {
  title: string;
  eyebrow?: string;
}

export function ScreenStub({ title, eyebrow = 'Stub' }: ScreenStubProps) {
  return (
    <AppFrame>
      <SectionHeader title={title} eyebrow={eyebrow} />
      <p style={{ color: 'var(--ink-3)', fontSize: 14 }}>
        Placeholder. Inhoud volgt in een latere fase.
      </p>
    </AppFrame>
  );
}
